import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';


let appInsights
export let reactPlugin

try {
    reactPlugin  = new ReactPlugin();
    appInsights = new ApplicationInsights({ 
        config: {
            connectionString: import.meta.env.VITE_AZURE_APP_INSIGHTS_CONNECTION,
            extensions: [reactPlugin],
            extensionConfig: {
              [reactPlugin.identifier]: { history: null }
            },
            enableAutoCollectConsole: false, // Turn off app insights logging to avoid circular references with console logging reporting
            loggingLevelConsole: 0, // Same as above, but know that becuase app Insights only runs in prod these could be turned on in dev env
        } 
    });
} catch (error) {
    console.log('Error initializiing application Insights', error)
}

export default appInsights